/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CollectionList(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CollectionList',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M1.01 5.447V6.56C1.01 7.353 2.795 8 5 8V6.38c-1.147 0-2.235-.164-3.065-.464a3.8 3.8 0 0 1-.925-.47zM9 3.56V2.44C9 1.645 7.21 1 5.005 1 2.798 1 1.01 1.645 1.01 2.44v1.12C1.01 4.358 2.798 5 5.005 5 7.21 5 9 4.357 9 3.56M1.01 8.453v1.11C1.01 10.356 2.795 11 5 11V9.384c-1.147 0-2.235-.164-3.065-.465a3.8 3.8 0 0 1-.925-.467zM6 6v1h5V6zm0 3h5V8H6zm0 2h5v-1H6z"}))
}
